import { Box, Flex, Text } from '@chakra-ui/react';
import ImgSellOutBanner from '../../assets/images';
import SpannedText from '@pages/UploadMappingV2/components/ui/spannedText';

export default function Banner({ ...props }) {
    return (
        <Box
            borderRadius={'8px'}
            overflow="hidden"
            bg={'semantic.100'}
            boxShadow={'0px 1px 3px 0px #0000001A'}
            {...props}
        >
            <Flex>
                <Box flexShrink={0}>
                    <ImgSellOutBanner />
                </Box>

                <Flex flexDir={'column'} justifyContent={'center'} p="16px" gap="8px">
                    <Text color={'sagitarius.500'} fontSize={'24px'} fontWeight={'700'}>
                        Kode Produk di Toko Berbeda? Mapping Produk Disini!
                    </Text>
                    <Text fontSize={'14px'}>
                        Jika ada perbedaan antara kode produk Paragon dengan kode produk di Toko kamu, mapping produk
                        tersebut secara <SpannedText>massal</SpannedText> atau
                        <SpannedText> satuan</SpannedText>. Terima kasih atas kerjasamanya!
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
}
